import React, { useCallback, useState } from 'react';
import { actionTypes } from 'reducer/actionType';
import { conditionalOptions } from 'lib/existingPatientOptions';
import SymptomsPage from 'components/existingPatient/symptoms';
import PainRateExistingPatient from 'components/existingPatient/painRateExistingPatient';
import HomeActivities from 'components/existingPatient/homeActivities';
import PageComplete from 'components/existingPatient/pageComplete';
import { Header } from 'components/common/header';
import useBeforeUnload from 'hooks/useBeforeUnload';

function ExistingPatientApp() {
  const totalPage = 3;
  const [currentPage, setCurrentPage] = useState(1);
  const [resultPage, setResultPage] = useState(false);
  useBeforeUnload(totalPage > currentPage);

  const nextOrSubmitButton = useCallback(
    (nextPage: number, submit?: boolean) => {
      if (submit) {
        setResultPage(true);
        setCurrentPage(100);
        return;
      }
      setCurrentPage(nextPage);
    },
    [],
  );

  const pageBackButton = (pageNumber: number) => {
    if (pageNumber === 0) {
      return;
    }
    setCurrentPage(pageNumber);
  };

  return (
    <div className="app-page-container">
      <Header
        currentPage={currentPage}
        totalPage={totalPage}
        onClickBackButton={pageBackButton}
      />
      <div className="pt-36 pb-20 px-3">

        {/* <PageOne /> */}
        {currentPage === 1 && (
        <SymptomsPage
          options={conditionalOptions}
          nextPage={2}
          multiple
          isFilter
          nextOrSubmitButton={nextOrSubmitButton}
          actionPage={actionTypes.PAGE_ONE}
        />
        )}
        {/* <Page Two /> */}
        {currentPage === 2 && (
        <PainRateExistingPatient
          options={conditionalOptions}
          nextPage={3}
          isFilter
          nextOrSubmitButton={nextOrSubmitButton}
          actionPage={actionTypes.PAGE_TWO}
          multiple={false}
        />
        )}

        {/* Page Three */}
        {currentPage === 3 && (
        <HomeActivities
          options={conditionalOptions}
          nextPage={4}
          isFilter
          nextOrSubmitButton={nextOrSubmitButton}
          actionPage={actionTypes.PAGE_THREE}
          multiple
        />
        )}

        {/* Page result */}
        {resultPage && <PageComplete />}
      </div>
    </div>
  );
}

export default ExistingPatientApp;
